<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            @sort="onSort"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="resolution_date" slot-scope="data">
                {{ data.item.resolution_date | datetime }}
            </template>
            <template slot="created_at" slot-scope="data">
                {{ data.item.created_at | datetime }}
            </template>
            <template slot="due_date" slot-scope="data">
                {{ data.item.due_date | datetime }}
            </template>
            <template slot="notes" slot-scope="data">
                <h5><b-badge pill variant="primary">{{ data.item.notes.length }}</b-badge></h5>
            </template>
            <template slot="files" slot-scope="data">
                <h5><b-badge pill variant="primary">{{ data.item.files.length }}</b-badge></h5>
            </template>
            <template slot="actions" slot-scope="data">
                <b-button size="sm" :variant="!data.detailsShowing?'primary':'danger'" @click.stop="data.toggleDetails"><i v-if="!data.detailsShowing" class="fa fa-eye"></i><i v-else class="fa fa-eye-slash"></i></b-button>
                <b-button size="sm" variant="primary" @click="createNote(data.item)"><i class="fa fa-pencil-square-o"></i></b-button>
            </template>
            <template slot="row-details" slot-scope="data">
                <app-task-details :the-data="data" />
            </template>
            <template slot="resolved" slot-scope="{ item }">
                <i class="fa fa-check fa-2x" v-if="!!item.resolution_date" style="color: green;"></i>
                <i class="fa fa-clock-o fa-2x" v-else aria-hidden="true" style="color: red;"></i>
            </template>
        </app-data-table>
    </div>
</template>
<script>
import fields from './fields';
import TaskDetails from '../../../../UI/Tasks/TaskDetails.vue';
import Paginator from '../../../../UI/Controls/Paginator/Paginator.vue';
export default {
    components: {
        appTaskDetails: TaskDetails,
        appPaginator: Paginator
    },
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields,
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data;
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('changePage', page);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
        createNote(data){
            this.$emit('create-note', data);
        },
    }
}
</script>